import {createStore} from 'vuex'

export default createStore({
    state() {
        return {
            pageTitle: "Bibliothek",
            reevaluateLogin: 0,
            confirmationOverlay: {},
            breadCrumbs: [],
            user: null,
            toast: {},
            libraryRightClickOverlay: {},
            libraryRightClickOverlayActions: null,
            tenantConfig: null,
            tenantStatus: null,
            isImpersonation: false,
        }
    },
    getters: {},
    mutations: {
        setPageTitle(state, title) {
            state.pageTitle = title;
            const appName = state.tenantConfig?.name || 'DisplayDeck';
            document.title = title + " | " + appName;
        },
        setTenantConfig(state, config) {
            state.tenantConfig = config;
            if(config?.logoUrl) {
                let link = document.querySelector("link[rel~='icon']");
                if(!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.head.appendChild(link);
                }
                link.href = config.logoUrl;
            }
        },
        setUser(state, user) {
            state.user = user;
        },
        setToast(state, status) {
            // visible:false bewusst durchlassen (zum Schliessen sticky-Toasts)
            if(status.visible !== false) {
                status.visible = true;
            }
            state.toast = status;
        },
        setRightClickActions(state, actions) {
            state.libraryRightClickOverlayActions = actions;
        },
        setTenantStatus(state, { tenantStatus, isImpersonation }) {
            state.tenantStatus = tenantStatus ?? null;
            state.isImpersonation = !!isImpersonation;
        },
        clearAccount(state) {
            state.user = null;
            state.tenantStatus = null;
            state.isImpersonation = false;
        },
    },
    actions: {
        // Guard-tauglich: eigener fetch (kein Mixin), liest sessionKey aus dem Cookie.
        async loadAccountStatus({ commit }) {
            const m = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('sessionKey='));
            const token = m ? decodeURIComponent(m.split('=')[1]) : null;
            if (!token) { commit('clearAccount'); return null; }
            try {
                const res = await fetch(window.location.origin + '/account', {
                    method: 'GET',
                    headers: { Authorization: 'Bearer ' + token },
                    cache: 'no-cache',
                });
                if (!res.ok) { commit('clearAccount'); return null; }
                const user = await res.json();
                commit('setUser', user);
                commit('setTenantStatus', { tenantStatus: user.tenantStatus, isImpersonation: user.isImpersonation });
                return { tenantStatus: user.tenantStatus ?? null, isImpersonation: !!user.isImpersonation };
            } catch (e) {
                commit('clearAccount');
                return null;
            }
        },
    },
    modules: {}
})
